module.exports = __webpack_public_path__ + "img/logo_docue_red.ca69482.svg";